import FunctionHeader from "presentation/components/Header/FunctionHeader";
import FormsInstanceGrid from "presentation/components/NimberForms/FormsInstanceGrid";
import ManageFormsContainer from "presentation/components/NimberForms/ManageFormsGrid";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { TabPanel, TabView } from "primereact/tabview";

const NimberFormsPage = ({ children }: { children?: React.ReactNode }) => {
    const { isLoading } = usePermissionCheck({ requiredFunction: "formsTemplate" });
    if (isLoading) {
        return <Spinner />;
    }

    return (
    <div>
        <FunctionHeader title="Nimber Forms" />
        <TabView>
            <TabPanel header="Formulários">
                <ManageFormsContainer />
            </TabPanel>
            <TabPanel header="Instâncias">
                <FormsInstanceGrid />
            </TabPanel>
        </TabView>
    </div>);
}

export default NimberFormsPage;